/**
 * 数据中心 - 简体中文
 */
export default {
  title: '数据中心',
  regionData: '区域数据',
  riskControlData: '风控数据',
  businessData: '业务数据',
  reconciliationData: '对账数据',
  agentVersion: '代理商最新进销存数据',
  agentVersionNew: '代理商阶段进销存数据',
  agencyActivation: '代理商激活数据',
  agencyActivationAgentId: '代理商ID',
  agencyActivationAgentName: '代理商名称',
  agentOrdering: '代理商订货数据',
  crossSubjectSupervisorQuota: '下级经销商跨主体督学额度',
  crossSubjectSupervisorAudit: '跨主体督学申请审核',
  // 跨主体督学额度 CrossSubjectSupervisorQuota
  statsPeriod: '统计周期',
  dealerOrg: '经销商组织架构',
  placeholderSelectDealer: '请选择经销商',
  dealerId: '经销商ID',
  dealerName: '经销商名称',
  belongArea: '所属区域',
  starAgentArea: '所在省市区',
  sameSubjectDxStudentCount: '服务同主体加入督学学员数',
  sameSubjectExemptLimit: '服务同主体免审核额度',
  sameSubjectUsedLimit: '服务同主体已使用额度',
  currentDealerUsedLimit: '当前经销商已使用额度',
  sameSubjectUpperLimit: '服务同主体上限额度',
  adjustQuota: '调整额度',
  partner: '合作伙伴：',
  sameSubjectDealers: '服务同主体经销商：',
  freeRatio: '免审核额度比例：',
  limitRatio: '上限额度比例：',
  placeholderFreeRatio: '请输入免审核额度比例',
  placeholderLimitRatio: '请输入上限额度比例',
  pleaseEnterValidNumber: '请输入有效数字',
  valueRangeZeroOne: '取值范围0~1',
  maxTwoDecimals: '最多支持两位小数',
  limitRatioMustGtFree: '上限额度比例必须大于免审核额度比例',
  adjustSuccess: '调整成功',
  adjustFail: '调整失败',
  adjustFailRetry: '调整失败，请重试',

  // dealerRestrictionManagement
  viewRestrictDetail: '查看限制详情',
  addRestriction: '新增限制',
  cancelRestriction: '取消限制',
  restrictRule: '限制规则',
  placeholderSelectRestrictRule: '请选择限制规则',
  restrictRuleName: '限制规则名称',
  restrictScope: '限制范围',
  placeholderSelectRestrictScope: '请选择限制范围',
  restrictReason: '限制原因',
  cancelRestrictReason: '取消限制原因',
  placeholderRestrictReason: '请输入限制原因',
  restrictReasonMinLength: '限制原因不能少于5个字符',
  addRestrictSuccess: '新增限制成功',
  cancelRestrictSuccess: '取消限制成功',
  dealerLocation: '所在地',
  restrictStatus: '限制状态',
  placeholderRestrictStatus: '请选择限制状态',
  statusUnrestricted: '未限制',
  statusRestricted: '已限制',
  schoolName: '经销商名称',

  // quotaManagement
  increaseQuota: '增加可购买额度',
  decreaseQuota: '扣减可购买额度',
  increaseAction: '增加',
  decreaseAction: '扣减',
  purchasableQuota: '可购买额度',
  dealerIdColon: '经销商ID：',
  dealerNameColon: '经销商名称：',
  remainQuotaColon: '剩余可购买额度：',
  changeQuotaColon: '可购买额度：',
  reasonColon: '原因：',
  placeholderNumber: '请输入数字',
  placeholderReasonRange: '请输入原因（5-100）字',
  placeholderReason: '请输入原因',
  reasonLengthRule: '请输入长度在 5 到 100 个字符的原因',
  totalLimit: '总可购买额度',
  buyLimit: '已购买额度',
  remainLimit: '剩余可购买额度',
  usedLimit: '已用额度',
  areaLabel: '所在区域',

  // Subscription (BusinessData)
  consumeNo: '使用流水号',
  placeholderConsumeNo: '请输入使用流水号',
  cardNo: '订阅卡卡号',
  placeholderCardNo: '请输入订阅卡卡号',
  useDate: '使用日期',
  rangeTo: '至',
  learningMachineAccount: '学习机账户',
  placeholderLearningMachineAccount: '请输入学习机账户',
  cardAgent: '订阅卡代理商',
  placeholderCardAgent: '请选择订阅卡代理商',
  machineAgent: '学习机代理商',
  placeholderMachineAgent: '请选择学习机代理商',
  useTime: '使用时间',
  useOperator: '使用操作人',
  renewArea: '续订区域',
  renewLevel: '续订档位',
  renewMonths: '续订月份数',
  cardType: '订阅卡类型',
  cardAgentId: '订阅卡代理商ID',
  cardAgentName: '订阅卡代理商名称',
  machineAgentId: '学习机代理商ID',
  machineAgentName: '学习机代理商名称',
  exportSubscriptionConsume: '订阅卡使用信息导出',

  // transformedData
  statsPeriodLabel: '统计周期',
  placeholderStatsPeriod: '请选择统计周期',
  placeholderSelect: '请选择',
  selectTimeRange: '请选择时间范围',
  dealerLocationArea: '经销商所在地',
  buyLimitCount: '购买额度数',
  openAccountNum: '开通账号数',
  oneTransformNum: '当月转化数',
  oneTransformRate: '当月转化率',
  twoTransformNum: '次月转化数',
  twoTransformRate: '次月转化率',
  threeTransformNum: '三个月转化数',
  threeTransformRate: '三个月转化率',
  totalTransformNum: '总转化数',
  totalTransformRate: '总转化率',

  // leagueMatchManage
  leagueSelect: '联赛选择',
  placeholderLeague: '请选择联赛',
  zoneSelect: '战区选择',
  placeholderZone: '请选择战区',
  dealerQuery: '经销商查询',
  placeholderDealerIdOrName: '请输入经销商ID或名称',
  queryByQuarter: '按季度查询',
  placeholderQuarter: '请选择季度',
  queryByMonth: '按月查询',
  placeholderMonth: '请选择月',
  clearFilter: '清除筛选',
  pleaseSelectLeague: '请选择联赛',
  pleaseSelectZone: '请选择战区',
  pleaseSelectQuarter: '请选择季度',
  pleaseSelectMonth: '请选择月份',
  allStarMatch: '全明星赛',
  superLeague: '超级联赛',
  firstDivision: '甲级联赛',
  allStarZone: '全明星战区',
  east: '东部',
  west: '西部',
  south: '南部',
  north: '北部',
  areaProvinceCity: '所在省市区',
  matchName: '所属比赛',
  leagueRank: '比赛排名',
  growthValue: '当前成长值',
  growthChange: '本月成长值变化',
  rankChange: '本月名次变化',
  quarterFormat: 'yyyy第Q季度',

  // promotionDashboard
  exportDetail: '导出明细',
  totalCountLabel: '汇总台数：',
  operationRemind: '操作提醒',
  exportConfirmText: '导出明细将按照当前筛选条件导出，请确认是否继续操作？',
  statsPeriodColon: '统计周期：',
  regionFilter: '地域筛选',
  placeholderRegion: '请选择地域',
  orgInfo: '组织信息',
  placeholderOrg: '请选择组织',
  promoterQuery: '推广大使查询：',
  placeholderPromoterName: '请输入推广大使姓名',
  salesPerson: '销售人员',
  registerTime: '注册时间',
  promoteCount: '推广台数',

  // ReconciliationData shared
  agent: '代理商',
  placeholderAgent: '请选择代理商',
  dispatchTime: '发货时间',
  createTime: '创建时间',
  placeholderStatus: '请选择状态',
  productType: '商品类型',
  placeholderProductType: '请选择商品类型',
  orderNoLabel: '采购订单编号：',
  deliverValuePlaceholderOrderNo: '请输入采购订单编号',
  payStatusColon: '支付状态:',
  orderStatusColon: '订单状态:',
  unpaid: '未付款',
  partialPay: '未完款',
  paid: '已收款',
  agentId: '代理商ID',
  agentName: '代理商名称',
  partnerIntroduceCustomerActivationAgentId: '代理商ID',
  partnerIntroduceCustomerActivationAgentName: '代理商名称',
  province: '省份',
  city: '城市',
  district: '区县',
  receiveAddress: '收货地址',
  receiver: '收货人',
  createTimeLabel: '创建时间',
  equipmentValueAgentId: '代理商ID',
  equipmentValueAgentName: '代理商名称',
  deliverValueAgentId: '代理商ID',
  deliverValueAgentName: '代理商名称',
  deliverValueRemarkLabel: '备注',
  // DeliverValue
  purchaseOrderNo: '采购单号',
  productName: '商品名称',
  productNameCol: '产品名称',
  orderQty: '订单数量',
  purchaseAmount: '采购金额',
  isReturnPay: '是否回款',
  orderStatus: '订单状态',
  transferQty: '调货数量',
  cashAmountWithVoucher: '现金金额（含提货券）',
  voucherAmount: '裂变金额',
  prepayFreight: '预付运费',
  dispatchAreaAgentId: '发货区代ID',
  dispatchAreaAgentName: '发货区代名称',
  expressNo: '发货单号',
  // EquipmentValue
  machineStatusColon: '设备状态:',
  inactive: '未激活',
  activated: '已激活',
  subscribed: '已订阅',
  frozen: '冻结',
  productNameColon: '商品名称：',
  placeholderProductName: '请输入商品名称',
  snCode: 'SN码',
  dispatchMonth: '发货月份',
  expressCompany: '物流公司',
  warehouse: '所在仓库',
  expressNoLabel: '物流单号',
  softActivateStatus: '软件激活状态',
  hardActivateStatus: '硬件激活状态',
  hardActivateTime: '硬件激活时间',
  latestOrderNo: '最新采购单号',
  freight: '运费',
  voucherPrice: '裂变单价',
  cashPrice: '现金单价',
  priceTotal: '单价合计',
  softActivateTime: '软件激活时间',
  softActivateMonth: '软件激活月份',
  firstDispatchTime: '首次发货时间',
  // PurchaseValue
  purchaseValueAgentId: '代理商ID',
  purchaseValueAgentName: '代理商名称',
  purchaseOrderNoShort: '采购单编号',
  purchaseValueDispatchType: '发货方式',
  dispatchType: '发货方式',
  payStatus: '支付状态',
  orderCreateTime: '采购单创建时间',
  purchaseProductName: '采购产品名称',
  isDoubleOrder: '是否双重订单',
  purchaseQty: '采购数量',
  dispatchNum: '发货数量',
  purchaseUnitPrice: '采购产品单价',
  purchaseTotalAmount: '采购总金额',
  paidCashAmount: '已付现金总金额',
  paidVoucherAmount: '已付裂变奖金抵扣金额',

  // 激活率 ActivationRate
  regionCampusId: '上级代理商ID',
  regionCampusName: '上级代理商名称',
  activationRateUpperAgentId: '上级代理商ID',
  activationRateUpperAgentName: '上级代理商名称',
  statPeriod: '统计周期',
  activeNum: '软件激活台数',
  activeOdds: '异地激活率',
  offsiteProviceNum: '异省激活台数',
  offsiteCityNum: '异市激活台数',
  offsiteDisNum: '异区激活台数',
  rangeSeparatorTo: '至',
  // 仓库库存 Inventory
  timeLabel: '时间',
  placeholderWarehouse: '请选择仓库',

  // 采集明细 CollectDetails
  dateLabel: '日期',
  studentLabel: '学员：',
  placeholderStudentName: '请输入学员姓名/账号',
  accountTypeLabel: '账号类型：',
  placeholderAccountType: '请选择账号类型',
  serviceCenterLabel: '服务中心：',
  placeholderCampusId: '请输入经销商ID',
  studentNameCol: '学员姓名',
  accountCol: '账号',
  phoneCol: '手机号',
  accountTypeCol: '账号类型',
  serviceCenterId: '服务中心ID',
  serviceCenterName: '服务中心名称',
  deviceSn: '设备SN码',
  faceBasePhoto: '人脸基准照片',
  photoCol: '图片',
  collectionTime: '采集时间',
  collectionMethod: '采集方式',
  livingDetectionMethod: '活体检测方式',
  livingScore: '活体得分',
  isRecognize: '是否识别',
  faceNum: '人脸数量',
  recognitionSimilarity: '识别相似度',
  recognitionResult: '识别结果',
  face1Age: '人脸1年龄',
  face1SimilarFaceInfo: '人脸1最相似人脸信息',
  face2Age: '人脸2年龄',
  face2SimilarFaceInfo: '人脸2最相似人脸信息',
  employeeAccount: '员工账号',
  traineeAccount: '学员账号',
  experienceAccount: '体验账号',
  prototypeAccount: '样机账号',
  rangeSeparatorTilde: '~',

  // 私下率 PrivateRate
  privateOdds: '私下率',
  privateNum: '私下台数',

  // 激活地 ActivationLocation
  statsPeriodColon: '统计周期:',
  placeholderStatsPeriodMonth: '请选择统计周期(按月)',
  activeLocationLabel: '活跃地:',
  placeholderActiveLocation: '请选择活跃地',
  queryBtn: '查询',
  exportAllRegionData: '导出全部区域数据',
  pleaseSelectStatsPeriod: '请选择统计周期',
  pleaseSelectActiveLocation: '请选择活跃地',
  learningMachineSn: '学习机SN码',
  authArea: '认证区域',
  campusLocation: '经销商所在地',
  parentAgentId: '上级代理商ID',
  parentAgentName: '上级代理商名称',
  activeStatPeriod: '活跃统计周期',
  activeLocationCol: '活跃地',
  isDifferentLocation: '是否异地',
  activeDays: '周期内活跃天数',
  lastActiveAddress: '最近一次活跃详细地址',
  longitude: '经度',
  latitude: '纬度',
  pleaseFillRequired: '请填写必填字段！',
  networkError: '网络错误',

  // 激活簇 ActivationCluster
  startDatePlaceholder: '开始日期',
  endDatePlaceholder: '结束日期',
  thisAddressActiveSn: '此地址激活SN码',
  activeAddress: '激活详细地址',
  provinceCityDistrict: '激活省市区',
  lonAndLat: '激活经纬度',
  statisticalCycle: '统计周期',
  thisAddressActiveNum: '此地址激活台数',
  standardDeviation: '离散程度',
  campusNum: '涉及经销商数量',
  campusIdString: '涉及经销商ID',
  campusNameString: '涉及经销商名称',
  nearestCampusId: '距离最近门店ID',
  nearestCampusName: '距离最近门店名称',
  campusToActiveDistance: '门店与激活地距离',
  openTime: '开业时间',
  campusAgentId: '门店经销商ID',
  campusAgentName: '门店经销商名称',
  isSameAgent: '经销商是否一致',
  campusProvinceCityDistrict: '门店所在省市区',
  campusAddress: '门店详细地址',
  campusLonAndLat: '门店经纬度',

  // 异常占比 AbnormalProportion
  dealerIdColon: '经销商ID：',
  placeholderEnterDealerId: '请输入经销商ID',
  statisticTime: '统计周期',
  errorStaffAccountNum: '异常员工账号数',
  errorStudentAccountNum: '异常学员账号数',
  errorMachineAccountNum: '异常样机/体验账号数',

  // 异常明细 ExceptionDetails
  placeholderSelectMonth: '请选择月份',
  collectNum: '采集次数',
  recognitionNum: '识别次数',
  errorNum: '异常次数',
  errorRate: '异常占比',
  errorDetail: '异常情况分类',
  serviceCenterIdCol: '服务中心ID',

  // 串货率 CollusionRate
  fleeingGoodsOdds: '串货率',
  fleeingGoodsNum: '串货台数',

  // 学员实名 StudentRealName
  studentTotal: '学员总数',
  realNameStudentTotal: '已实名学员数',
  realNameRate: '实名率',
  activeStudentTotal: '活跃学员数（本月）',
  realNameActiveStudentTotal: '已实名活跃学员（本月）',
  realNameActiveRate: '活跃学员实名率（本月）',
  locationAddress: '所在地',

  // 跨区域活跃设备 CrossRegActiveEquipment
  snCodeLabel: '设备SN码',
  placeholderSnCode: '请输入设备SN码',
  dealerLabel: '经销商',
  placeholderDealerIdName: '请输入经销商ID/名称',
  statusLabel: '状态',
  placeholderStatus: '请选择状态',
  statusNormal: '正常',
  statusBuffer: '缓冲期',
  statusLocked: '已锁定',
  statusAppeal: '申诉待审核',
  softwareActivationDateLabel: '软件激活日期',
  placeholderSoftwareActivationRange: '请选择软件激活日期范围',
  lockDateLabel: '锁机日期',
  placeholderLockDateRange: '请选择锁机日期范围',
  deviceModel: '设备型号',
  softActivateTime: '软件激活时间',
  activeProvinceCity: '软件激活省市区',
  crossRegActiveDate: '跨区域活跃日期',
  crossRegActiveProvinceCity: '跨区域活跃省市区',
  dataSourceNameCol: '数据来源',
  handleTypeName: '状态',
  handleTime: '锁机日期',
  exportBtn: '导出',

  // 跨主体督学审核 CrossSubjectSupervisorAudit / CrossEntitySupervisionDialog
  crossEntityApplyDetail: '跨主体督学申请详情',
  crossEntityAuditTitle: '审核跨主体督学申请',
  crossEntityApplyTitle: '跨主体督学申请',
  studentAccountLabel: '学员账号：',
  studentNameLabel: '学员姓名：',
  deviceDealerIdLabel: '设备经销商ID：',
  deviceDealerNameLabel: '设备经销商名称：',
  transferServiceCenterIdLabel: '转入服务中心ID：',
  transferServiceCenterNameLabel: '转入服务中心名称：',
  descriptionLabel: '情况说明：',
  evidenceFilesLabel: '证明文件：',
  auditResultLabel: '审核结果：',
  placeholderSelectAuditResult: '请选择审核结果',
  remarkLabel: '备注：',
  placeholderRemark: '请输入备注',
  enterRemarkRequired: '请输入备注',
  rejectRemarkRequired: '审核驳回时请输入备注',
  remarkLengthRule: '备注长度为2-100字',
  remarkMinLength: '备注长度不能少于2字',
  remarkMaxLength: '备注长度不能超过100字',
  submitAudit: '提交审核',
  auditSubmitSuccess: '审核提交成功',
  submitFailed: '提交失败',
  submitFailedRetry: '提交失败，请稍后重试',
  preview: '预览',
  placeholderTransferServiceCenterId: '请输入转入服务中心ID',
  studentNameAccountLabel: '学员姓名账号：',
  placeholderStudentNameOrAccount: '请输入学员姓名或账号',
  auditStatusLabel: '审核状态：',
  placeholderAuditStatus: '请选择审核状态',
  pendingAudit: '待审核',
  auditApproved: '审核通过',
  auditRejected: '审核驳回',
  applySubmitTimeLabel: '申请提交时间：',
  placeholderTimeRange: '请选择时间范围',
  auditBtn: '审核',
  viewDetail: '查看详情',
  studentUserName: '学员姓名',
  studentAccountUser: '学员账号',
  deviceDealerId: '设备经销商ID',
  deviceDealerName: '设备经销商名称',
  transferServiceCenterIdCol: '转入服务中心ID',
  transferServiceCenterName: '转入服务中心名称',
  applyStatusName: '申请状态',
  applySubmitTimeCol: '申请提交时间',
  applySubmitUser: '申请提交人',
  reviewTimeCol: '审核时间',
  reviewerCol: '审核人',

  // 区域数据 RegionData 通用
  agentVersionTip: '查询区域内所有代理商的历史累计进货量、激活量及最新库存量',
  agentVersionAgentId: '代理商ID',
  agentVersionAgentName: '代理商名称',
  regionCol: '区域',
  purchaseQtyExcludeSample: '进货量（不含样机亲子机）',
  activeQtyExcludeSample: '激活量（不含样机亲子机）',
  stockQtyExcludeSample: '库存量（不含样机亲子机）',
  stockQtySample: '库存量（样机亲子机）',
  activateTimeLabel: '激活时间',
  agentAreaLabel: '代理商所属区域',
  belongProvinceCity: '所属省市',
  agentOrderingAgentId: '代理商ID',
  agentOrderingAgentName: '代理商名称',
  hardwareActiveCnt: '硬件激活量（非样机）',
  hardwareMachineCnt: '硬件激活量（样机）',
  hardwareChildMachineCnt: '硬件激活量（亲子机）',
  softwareActiveCnt: '软件激活量（非样机）',
  softModelMachineCnt: '软件激活量（样机）',
  softChildMachineCnt: '软件激活量（亲子机）',
  modelNameCol: '商品类型',
  orderTimeLabel: '下单时间',
  orderingTip: '注：订货量统计，已确认的区域调货订单数量 + 总部已完款订单数量',
  buyNumCol: '订货量',
  dispatchDateLabel: '发货日期',
  agentVersionNewTip: '查询区域内所有代理商某个时间段的进货量、激活量及最新库存量',

  // 销售转化 SellTransData
  belongArea: '所属区域',
  potentialCustomers: '潜在客户总数',
  addPotentialCustomers: '新增潜在客户数',
  invitations: '邀约数',
  activeMachineC: '学习机C端激活',

  // 代理商生命周期 AgentLifeCycle
  placeholderCampusId: '请输入经销商ID',
  areaName: '所在省市区',
  lifeCycleLabel: '生命周期',
  placeholderAll: '全部',
  lifeCycleCol: '生命周期',
  joinTime: '加入时间',
  newbieProgress: '新手期进展',
  performanceProgress: '业绩进展',
  exportCurrentDetail: '导出当前明细',

  // 非省代续费激活量考核表 RenewalActivationQuantity
  renewalActivationAgentId: '代理商ID',
  renewalActivationAreaName: '区县/城市',

  // 校区订阅明细 CampusSubStatDetail
  placeholderSelectPeriod: '请选择统计周期',
  dispatchTimeLabel: '发货时间',
  campusSubStatDetailAgentId: '代理商ID',
  campusSubStatDetailAgentName: '代理商名称',
  agentServiceId: '代理商服务商ID',
  agentServiceName: '代理商服务商名称',
  consumeNum: '消耗订阅月份数',
  missSubReturnNum: '误订阅返还月份数',
  basicNum: '返还月份基数',

  // 代理商仓库 AgentWarehouse
  campusAllInventory: '代理商总库存',
  warehouseInventory: '云仓总库存',
  storeInventory: '门店总库存',

  // 跨区域汇总 AgentCrossRegionalSummary
  reportTimeLabel: '报备时间',
  crossRegionReportAgentId: '代理商ID',
  crossRegionReportAgentName: '代理商名称',
  crossTypeName: '跨区域类型',
  reportNum: '报备数量',
  reportActiveNum: '报备激活数量',
  reviewNum: '复核数量',
  reviewNoComplianceNum: '复核不合规数量',

  // 货款返还 SyRegionCashBack / 订阅费返佣 SyRegionSubFeeRebate
  regionAgentLabel: '区域代理',
  cashBackAgentId: '代理商ID',
  cashBackAgentName: '代理商名称',
  orderNoColon: '采购单编号：',
  placeholderOrderNo: '请输入采购单编号',
  orderNoLabelShort: '订单编号',
  placeholderOrderNoShort: '请输入订单编号',
  orderNo: '采购单编号',
  cashBackBuyNum: '订购数量',
  cashBackOrderAmount: '订单金额',
  orderAmount: '采购金额',
  cashTotal: '现金总金额',
  goldAccount: '金账户',
  cashPay: '现金支付',
  cashReward: '现金奖励',
  paymentRefundPay: '货款返现支付',
  deliveryVoucherAmount: '提货券支付金额',
  fissionDeduction: '裂变奖金抵扣金额',
  productionStatus: '生产状态',
  transferQty: '调货数量',
  dispatchRegionId: '发货区代ID',
  dispatchRegionName: '发货区代名称',
  returnAgentId: '返还代理ID',
  returnAgentName: '返还代理名称',
  deliveryTimeCol: '发货时间',
  rechargeAmount: '充值金额',
  rechargeTimeCol: '充值时间',
  rechargeIdCol: '充值ID',
  accountTypeCol: '账户类型',
  payMethod: '支付方式',
  flowStatus: '流水状态',
  confirmBy: '确认人',
  confirmTimeCol: '确认时间',
  confirmRemark: '确认备注',
  payStatus: '支付状态',
  orderStatus: '订单状态',
  receiveBuyNum: '发货数量',
  productPrice: '产品单价',
  dispatchTimeStr: '订单发货时间',
  dispatchType: '发货类型',
  dispatchCampusId: '发货区代ID',
  dispatchCampusName: '发货区代名称',
  regionCampusId: '区代ID',
  regionCampusName: '区代名称',
  totalProductSubFee: '订阅费现金金额',
  shareholdingRatio: '股权比例(%)',
  partnerRewardRatio: '合伙人转介绍客户奖励系数(%)',
  subscriptionFee: '订阅费返佣',
  addedFee: '增值服务费',

  // 现金支付报表 CashPaymentStatement
  profitTimeLabel: '权益开始时间',
  cashPaymentAgentId: '代理商ID',
  cashPaymentAgentName: '代理商名称',
  campusName: '代理商名称',
  agentTypeName: '代理商类型',
  periodStartDate: '权益开始日期',
  periodEndDate: '权益结束日期',
  regionPayAmount: '区域内现金支付金额',
  regionWithdrawalAmount: '区域内代理提现金额',
  regionSurplusAmount: '区域内结余现金金额',

  // HighActivity
  highActivityTip: '自 2024 年 4 月起，经销商考核政策更新，本报表数据仅用于追踪下级经销商的高活数据，2024 年 4 月份起，不再更新月排名。如需关注考核数据，请查看',
  highActivityLink: '“下级经销商、主体打基础考核数据”',
  agentId: '经销商ID',
  agentName: '经销商名称',
  monthCol: '月份',
  rank: '排名',
  conutryRate: '月全国平均高活综合占比（活跃加权）',
  totalRate: '月高活综合占比（活跃加权）',
  weekBegin: '周',
  weektotalRate: '周高活综合占比（活跃加权）',
  weekRealRatio: '周高活占比（实际）',
  weekRatio: '周高活占比（活跃加权）',
  weekHealthRate: '周健康占比',
  activeCount: '周5星人科数',
  weekHealthCount: '周健康人科数',
  activeTotalCount: '周活跃人数',

  // 合伙人转介绍客户激活 PartnerIntroduceCustomerActivation
  placeholderSoftwareActiveTime: '请选择软件激活时间',
  addressFull: '所属省市',
  hardwareMachineCnt: '硬件激活量（样机）',
  hardwareChildMachineCnt: '硬件激活量（亲子机）',
  softModelMachineCnt: '软件激活量（样机）',
  softChildMachineCnt: '软件激活量（亲子机）',

  // 续费激活量 RenewalActivationQuantity
  isMunicipalityName: '是否直辖市区县',
  lastYearActivation: '前一年激活量',
  incrementValue: '增量目标',
  periodActivation: '本周期内激活量',
  targetGap: '目标差距',

  // 区域校区订阅业绩 RegionCampusSubAchievement
  receiveNum: '已发货数量',
  dispatchTypeName: '发货方式',
  receivedAmount: '实收金额',
  dlAmount: '现金支付金额',
  lbAmount: '裂变支付金额',
  orderCreateTimeStr: '下单时间',
  completionTimeStr: '完款时间',
  receiveConfirmTimeStr: '收货确认时间',
  totalReturnAmount: '返还总金额',
  dlReturnAmount: '返还现金金额',
  lbReturnAmount: '返还裂变金额',
  returnTimeCol: '返还时间',

  // 服务跨区域汇总 ServiceCrossRegionalSummary
  dealerLabel: '经销商',
  timeLabel: '时间',
  yearMonth: '年月',
  protectionCnt: '额度',
  exportBtn: '导出',

  // 订单流水 RegionOrderFlowRecord
  regionAgentLabelLong: '区域代理商',
  changeTimeLabel: '变更时间',
  purchaseAgentId: '采购代理商ID',
  purchaseAgentName: '采购代理商名称',
  purchaseOrderNo: '采购单号',
  oldDispatchCampusId: '前发货代理商ID',
  oldDispatchCampusName: '前发货代理商名称',
  newDispatchCampusId: '现发货代理商ID',
  newDispatchCampusName: '现发货代理商名称',
  changeTimeCol: '变更时间',
  opUserName: '操作人',

  // 下级经销商打基础高活 HighActivityMain
  mainName: '主体',
  assessQuarter: '考核季度',
  quarterRank: '季度排名',
  assessStatus: '考核状态',
  avgRateQuarter: '季度全国平均高活综合占比（活跃加权）',
  avgRateActualQuarter: '季度全国平均高活综合占比（实际）',
  totalRateQuarter: '季度高活综合占比（活跃加权）',
  totalRateActualQuarter: '季度高活综合占比（实际）',
  lastTotalRateActual: '上季度高活综合占比（实际）',
  monthName: '月',
  isRecord: '月份是否计入考核',
  monthTotalActiveRate: '月高活综合占比（活跃加权）',
  monthActiveRate: '月高活占比（活跃加权）',
  monthActiveTrueRate: '月高活占比（实际）',
  monthHealthRateCol: '月健康占比',
  highActiveCountCol: '月周均5星人科数',
  monthHealthCountCol: '月周均健康人科数',
  monthActiveCountCol: '月周均活跃人数',

  // Partner 资料管理 CustomerOrderDetails
  materialNameLabel: '资料名称',
  placeholderMaterialName: '请输入资料名称',
  materialNameCol: '资料名称',
  catalogNameCol: '所属分类',
  materialPreviewCol: '资料预览',
  updateTimeCol: '最后编辑时间',
  updateByNameCol: '最后编辑人',
  createMaterialBtn: '创建资料',
  statusPendingPublish: '待发布',
  statusPublished: '已发布',
  publishShort: '发布',
  cancelPublishShort: '取消发布',
  thisAddressActiveSnCol: '此地址激活SN码',
  yearMonthCol: '月份',
  softActiveCountCol: '软件激活台数',
  studentNumCol: '学员数量',
  ddjRankCol: '全国高活排名',
  totalRatioCol: '月综合占比',
  activeRatioCol: '月高活占比',
  healthRatioCol: '月健康占比',
  activeCountCol: '月周均活跃',

  // StarAgentOperation 星级代理商
  areaQueryLabel: '区域查询：',
  placeholderArea: '请选择代理商所属区域',
  starFilterLabel: '星级筛选：',
  placeholderStar: '请选择星级',
  quarterFilterLabel: '季度筛选：',
  collapse: '收起',
  expand: '展开',
  clearFilterTip: '清除筛选',
  dealerQueryLabel: '经销商查询：',
  placeholderDealerIdOrName: '请输入经销商ID或名称',
  sortRuleLabel: '排序规则：',
  placeholderSortRule: '请选择排序规则',
  queryBtn: '查询',
  historyActivateNumCol: '历史累计激活台数',
  unitTai: '台',
  monthWeekActiveNumCol: '当前月周均活跃学员数',
  unitPerson: '人',
  currentStarLevelCol: '当前星级',
  over5Star: '超5星',
  starSuffix: '星',
  currentGrowthValueCol: '当前成长值',
  nationalRankCol: '全国排名',
  relegationNeedGrowthCol: '保级所需成长值',
  upgradeNeedGrowthCol: '升级所需成长值',
  reachedUpgrade: '已达升级条件',
  estimatedNextStarCol: '预估下季星级',
  adjustStarBtn: '增减星级',
  adjustGrowthBtn: '增减成长值',
  viewGrowthDetailBtn: '查看成长值明细',
  currentStarLabel: '当前星级：',
  adjustStarLabel: '增减星级：',
  increaseStar: '增加星级',
  decreaseStar: '减少星级',
  starQtyLabel: '星级数量：',
  increase: '增加',
  decrease: '减少',
  oneStarLevel: '1星级',
  starAdjustTip: '单次操作仅支持1星级的增减',
  adjustReasonLabel: '增减原因：',
  placeholderReasonMin10: '请输入不少于10个字',
  currentGrowthLabel: '当前成长值：',
  adjustGrowthLabel: '增减成长值：',
  increaseGrowth: '增加成长值',
  decreaseGrowth: '减少成长值',
  growthValueLabel: '成长值：',
  placeholderEnterNumber: '请输入数字',
  operationRecordCol: '操作记录',
  afterStarLevelCol: '操作后星级',
  reasonCol: '原因',
  view: '查看',
  operationTimeCol: '操作时间',
  operatorCol: '操作人',
  operationReasonTitle: '操作原因',
  close: '关 闭',
  growthProcessCol: '成长过程',
  growthValueCol: '成长值',
  finishTimeCol: '完成时间',
  gotIt: '我知道了',
  adjustStar: '增减星级',
  adjustGrowth: '增减成长值',
  growthValueDetail: '成长值明细',
  sortAll: '全部',
  sortGrowthAsc: '成长值正序',
  sortGrowthDesc: '成长值倒序',
  sortStarAsc: '星级正序',
  sortStarDesc: '星级倒序',
  ruleReasonRequired: '请输入增减原因',
  ruleReasonLength: '请输入长度在 10 到 200 个字符的增减原因',
  ruleGrowthValueRequired: '请输入成长值',
  ruleSelectStar: '请选择增减星级',
};
